export default __webpack_public_path__ + "static/media/GEFlogo.31288559.png";